/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import imageModifier from '../../../../utils/imageModifier';
import getPostBySlug from '../../../../api/graphql/queries/getPostBySlug';


const DraggableListContent = ({
  index,
  deleteItemHandler,
  component,
  itemsProperties,
  handlerSetItemsPropertiesInParent,
}) => {
  const styles = {
    position: 'absolute',
    width: '94%',
    height: '40px',
    marginLeft: '50px',
    overflow: 'visible',
    pointerEvents: 'auto',
    transformOrigin: '50% 50% 0px',
    bordeRadius: '5px',
    color: 'white',
    paddingLeft: '32px',
    fontSize: '14.5px',
    background: '#c8c8c8',
    textTransform: 'uppercase',
    letterSpacing: '0px',
    boxShadow: 'rgba(0, 0, 0, .6) 0px 1px 1px 0px',
  };

  const [slugName, setSlugName] = useState(component);
  const [pInfo, setPostInfo] = useState(null);

  const fetchPostInfo = async (comp) => {
    const res = await getPostBySlug(comp);
    if (res && res.post) {
      const { post: { postDescription } } = res;
      const image = postDescription && postDescription.image && postDescription.image.en ? postDescription.image.en : '';
      const title = postDescription && postDescription.title && postDescription.title.en ? postDescription.title.en : res.post.slugName;
      setPostInfo({ image, title });
    }
  };

  useEffect(() => {
    setSlugName(component);
    fetchPostInfo(component);
  }, [component]);

  return (
    <div
      className="bg-greyFilter w-full rounded-lg flex items-center trans trans-opacity relative cursor-move"
      style={styles}
    >
      <div
        className="absolute pin-r pin-t flex items-end mt-1 mr-1 cursor-pointer"
        onClick={() => {
          deleteItemHandler(index);
        }}
      >
        <span className="font-icon icon-close-solid text-16 text-white" />
      </div>
      {slugName
        && (
        <div className="flex items-center justify-between w-full text-black font-bold pl-4">
          <div className="h-full rounded-tl-lg rounded-bl-lg flex bg-greyFilterItems text-greyFilter absolute px-1 z-5 pin-l pin-t flex items-center justify-center text-30 pb-4px w-10">=</div>
          <span>
            {pInfo && pInfo.title}
            <br />
            <span className="text-xxs font-light">{slugName}</span>
          </span>
          {pInfo ? (
            pInfo.image.includes('svg')
              ? <img className="mr-8" height="40px" width="40px" src={pInfo.image} alt={slugName} />
              : <img className="mr-8" width="40px" src={imageModifier(pInfo.image, '40x40')} alt={slugName} />
          ) : null}
        </div>
        )
      }
    </div>
  );
};

DraggableListContent.propTypes = {
  component: PropTypes.string,
  deleteItemHandler: PropTypes.func,
  index: PropTypes.number,
  itemsProperties: PropTypes.shape(),
  handlerSetItemsPropertiesInParent: PropTypes.func.isRequired,
};
DraggableListContent.defaultProps = {
  component: null,
  index: 0,
  deleteItemHandler: () => { console.log('no handler passed from parent'); },
  itemsProperties: {},
};

export default DraggableListContent;
